import React from 'react'
import cx from 'classnames'

import { Text } from 'components/dataDisplay'
import { Href } from 'components/navigation'

import s from './NewCard.scss'


type NewCardProps = {
  className?: string
  image: string
  title: string
  date: string
  to: string
}

const NewCard: React.FC<NewCardProps> = (props) => {
  const { className, title, image, date, to } = props

  return (
    <Href className={cx('flex', className, s.root)} to={to}>
      <div className={cx('radius-8 no-shrink relative', s.imageBox)}>
        <div
          className={cx('radius-8 object-fill', s.image)}
          style={{ backgroundImage: `url(${image})`, backgroundSize: 'cover', width: '123px', height: '76px', filter: 'blur(10px)' }}
        />
        <div
          className={cx('radius-8 object-fit absolute', s.image)}
          style={{ backgroundImage: `url(${image})`, backgroundSize: 'contain', top: '0px', left: '0px',
            minWidth: '100%', minHeight: '100%', backgroundPosition: 'center' }}
        />
      </div>
      <div className="ml-20px flex flex-col">
        <Text
          className={s.title}
          message={title}
          title={title.length > 60 ? title : null}
          color="titanic"
          size="c20"
        />
        <Text
          className={cx('mt-8px', s.date)}
          message={date}
          color="titanic"
          size="t16-20"
        />
      </div>
    </Href>
  )
}

export default NewCard